import ClientListTable from 'modules/notification/components/ClientListTable/ClientListTable';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const ClientListPage = () => {
    return (
        <div>
            <ClientListTable />
        </div>
    );
};

export default ClientListPage;
